var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsychiatry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50009 5C4.50009 2.51472 6.51481 0.5 9.00009 0.5C11.4854 0.5 13.5001 2.51472 13.5001 5C13.5001 7.48528 11.4854 9.5 9.00009 9.5C6.51481 9.5 4.50009 7.48528 4.50009 5Z",
    fill: "#06CBAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.751333 19.1053C0.828673 14.6156 4.49207 11 9.00009 11C13.5082 11 17.1717 14.6157 17.2488 19.1056C17.254 19.4034 17.0824 19.676 16.8117 19.8002C14.4328 20.8918 11.7866 21.5 9.00041 21.5C6.21395 21.5 3.56752 20.8917 1.18841 19.7999C0.917738 19.6757 0.746203 19.4031 0.751333 19.1053Z",
    fill: "#06CBAD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychiatry);
export default __webpack_public_path__ + "static/media/psychiatry.86cdf41efea3c59b20e718466509357e.svg";
export { ForwardRef as ReactComponent };